type Props = {
  className?: string;
};

const AndroidDictationDemoVideo = ({ className = "" }: Props) => (
  <div
    className={`w-full max-w-[300px] overflow-hidden rounded-[28px] bg-[var(--bg-secondary)] shadow-xl ring-1 ring-[var(--hairline)] ${className}`}
  >
    <video
      aria-hidden
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      poster="/android-dictation-demo-start.webp"
      className="block w-full motion-reduce:hidden"
    >
      <source src="/android-dictation-demo.mp4" type="video/mp4" />
    </video>
    <img
      src="/android-dictation-demo-result.webp"
      alt=""
      className="hidden w-full motion-reduce:block"
    />
  </div>
);

export default AndroidDictationDemoVideo;
